<div class="email-mfa-wrapper">
  <div class="email-mfa-dialog">
    <button class="close-btn" (click)="close()">&times;</button>

    <div class="dialog-header">
      <h2 *ngIf="step === 1">Set Up Email Two Factor Authentication</h2>
      <h2 *ngIf="step === 2">Enter code</h2>
      <h2 *ngIf="step === 3">Verified successfully!</h2>
    </div>

    <!-- Step 1 -->
    <form *ngIf="step === 1" [formGroup]="form" class="form-content">
      <!-- <mat-checkbox formControlName="useAccountEmail" class="mfa-checkbox">
        <span class="text-[#18191C] font-[500]">Use my Account Login Email</span>
      </mat-checkbox> -->

      <div class="form-group">
        <mat-form-field appearance="fill" class="form-group"   [class.custom-disabled]="form.get('useAccountEmail')?.value" [disabled]="form.get('useAccountEmail')?.value">
          <mat-label class="text-[#25508E]">Email</mat-label>
          <input matInput id="email" formControlName="email" type="email"  class="text-[#18191C] font-semibold"/>
        </mat-form-field>
      </div>

      <button mat-flat-button color="primary" class="submit-btn w-[100%]" type="button"
              [disabled]="form.invalid" (click)="sendOtp()">
        Get One Time Password
      </button>
    </form>

    <!-- Step 2 -->
    <div *ngIf="step === 2" class="step-otp">
      <p class="subtitle">
        Enter the six digit code that we sent to your email to finish setting up two factor authentication.
      </p>
      <div class="app__centered-item">
        <ng-otp-input
          (keyup.enter)="enableMFA()"
          (onInputChange)="onOtpChange($event)"
          [config]="{ 
            length: 6, 
            allowNumbersOnly: true,
            inputStyles: { width: '48px', height: '48px' },
            containerStyles: { 'justify-content': 'center' },
            allowPaste: true
          }"
        ></ng-otp-input>
      </div>
      <p class="multifactor__authentication--counter mt-3">
        Code will expire in <b> {{ transform(counter) }} </b>
      </p>
      <div *ngIf="errorMsg" class="error-msg text-red-500">{{ errorMsg }}</div>
      <button 
      style="width: 20%"
              [class]="
              !(otp && otp?.length == 6) ? ' app__btn--disabled pointer-events-none' : 'app__btn--primary'
            "
              (click)="verifyOtp()">
        Verify
      </button>
      <p class="resend-msg">
        Did not receive code? <a (click)="resendOtp()"><strong class=" cursor-pointer" [ngClass]="transform(counter) === '00:00' ? 'text-[#25508E]' : 'text-[#888]'">Resend</strong></a>
      </p>
    </div>

    <!-- Step 3 -->
    <div *ngIf="step === 3" class="step-success">
      <img src="assets/images/verify-circel-logo.svg" alt="check-circle" class="success-img">
      <p class="success-msg">Email Two Factor Authentication successfully enabled.</p>
    </div>
  </div>
</div>
